import type { DiscussionsProps } from 'hb-builder/components/BuilderComponents/dynamic/Slider/SliderLayouts/DiscussionsWrapper';
import { goToModuleDetailPage } from 'hb-builder/utils/goToModuleDetailPage';

export const mapDiscussionsList = ({
  discussions,
  ids,
  isBackOffice,
  navigate,
}: {
  discussions: DiscussionsProps['data'];
  ids?: DiscussionsProps['ids'];
  isBackOffice: boolean;
  navigate?: DiscussionsProps['navigate'];
}) =>
  discussions?.map((discussion) => {
    const {
      id,
      comments: { count: commentsCount },
      created_at: createdAt,
      likes,
      title,
      user,
    } = discussion;

    return {
      comments: {
        total: commentsCount,
      },
      id,
      likes,
      onClick: () =>
        ids &&
        navigate &&
        goToModuleDetailPage({
          ids,
          isBackOffice,
          navigate,
          discussion,
        }),
      createdAt,
      title,
      user,
    };
  });
